/** Local free Unsplash photos (downloaded to /public/blog). */
export const BLOG_IMAGES = {
  featured: {
    src: "/blog/featured-rera.jpg",
    alt: "Modern high-rise real estate skyline"
  },
  "hmda-vs-dtcp-approved-layouts": {
    src: "/blog/hmda-dtcp.jpg",
    alt: "House keys on a property document for layout approval checks"
  },
  "how-to-verify-plot-before-buying-hyderabad": {
    src: "/blog/verify-plot.jpg",
    alt: "Open land and fields representing plot verification"
  },
  "best-areas-to-buy-open-plots-near-hyderabad": {
    src: "/blog/open-plots.jpg",
    alt: "Suburban neighbourhood rooftops near a growing city"
  },
  "rera-registered-projects-hyderabad": {
    src: "/blog/rera-search.jpg",
    alt: "Person reviewing documents while researching RERA projects"
  },
  "what-is-lp-number-in-real-estate": {
    src: "/blog/lp-number.jpg",
    alt: "Blueprint plans used to understand layout permission numbers"
  },
  "ai-real-estate-search-india": {
    src: "/blog/ai-search.jpg",
    alt: "Laptop and notes used for smarter AI-assisted property research"
  },
  "real-estate-project-listing-online-india": {
    src: "/blog/developer-listing.jpg",
    alt: "Construction site representing developer project listings"
  }
};

export const getBlogCover = (slug) => BLOG_IMAGES[slug] || BLOG_IMAGES.featured;
